var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"app-user-dialog app-dialog",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"label":"Комментарий","box":"","no-resize":""},model:{value:(_vm.model.description),callback:function ($$v) {_vm.$set(_vm.model, "description", $$v)},expression:"model.description"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }